/**
 * 飛鏢機卡（實體 IC 卡） — 對應 Categories #07 dart-card。
 * 對應 API: GET /api/dart-cards
 *
 * 客戶買實體卡 → 收貨 → 啟用綁定 Player ID → 卡片可插入機台記錄戰績、主題、戰績雲端同步。
 * 部份卡型已附贈虛擬主題（bundledVirtualIds 指向 VIRTUAL_PRODUCTS.id）。
 */

export const CARD_BRANDS = {
  DARTSLIVE: 'DARTSLIVE',
  PHOENICA:  'PHOENICA',
};

export const CARD_BRAND_LABELS = {
  [CARD_BRANDS.DARTSLIVE]: 'DARTSLIVE',
  [CARD_BRANDS.PHOENICA]:  'PHOENICA',
};

/**
 * 卡面色系 → 對應 CSS .dc-face.<theme> 渲染。
 */
export const CARD_FACE_THEMES = {
  GOLD:    'gold',
  PLATINUM:'platinum',
  NAVY:    'navy',
  RED:     'red',
  BLACK:   'black',
};

export const DART_CARDS = [
  {
    id: 'dartslive-3rd-classic',
    name: 'DARTSLIVE CARD · 第三代 經典款',
    en: 'D3 GEN · CLASSIC NAVY',
    brand: CARD_BRANDS.DARTSLIVE,
    cardModel: 'D3 Gen-3',
    faceTheme: CARD_FACE_THEMES.NAVY,
    bundledVirtualIds: [],
    bundledThemeCount: 0,
    price: 580,
    stock: 42,
    features: ['機台插卡記錄戰績', '雲端同步個人設定', '可綁定 DARTSLIVE 帳號'],
  },
  {
    id: 'dartslive-3rd-michi',
    name: 'DARTSLIVE CARD · 第三代 道限定款',
    en: 'D3 GEN · MICHI EDITION',
    brand: CARD_BRANDS.DARTSLIVE,
    cardModel: 'D3 Gen-3',
    faceTheme: CARD_FACE_THEMES.GOLD,
    bundledVirtualIds: ['aurora', 'neon-tokyo'],
    bundledThemeCount: 2,
    price: 980,
    stock: 18,
    features: ['限量燙金卡面 · 編號 0001-0500', '附贈 2 款主題', '可線上客製卡背簽名'],
  },
  {
    id: 'dartslive-2nd-basic',
    name: 'DARTSLIVE CARD · 第二代',
    en: 'D2 GEN · BASIC',
    brand: CARD_BRANDS.DARTSLIVE,
    cardModel: 'D2 Gen-2',
    faceTheme: CARD_FACE_THEMES.RED,
    bundledVirtualIds: [],
    bundledThemeCount: 0,
    price: 380,
    stock: 76,
    features: ['相容 D2 機台', '基礎戰績記錄', '可升級至 D3 帳號'],
  },
  {
    id: 'phoenica-pro',
    name: 'PHOENICA CARD · PRO',
    en: 'PHOENIX SERIES · PRO',
    brand: CARD_BRANDS.PHOENICA,
    cardModel: 'Phoenix Pro',
    faceTheme: CARD_FACE_THEMES.BLACK,
    bundledVirtualIds: ['cyber'],
    bundledThemeCount: 1,
    price: 680,
    stock: 24,
    features: ['鳳凰機台原廠 IC 卡', '附贈 CYBER 主題', 'PHOENIXdarts APP 連動'],
  },
  {
    id: 'phoenica-platinum',
    name: 'PHOENICA CARD · PLATINUM',
    en: 'PHOENIX · PLATINUM EDITION',
    brand: CARD_BRANDS.PHOENICA,
    cardModel: 'Phoenix Platinum',
    faceTheme: CARD_FACE_THEMES.PLATINUM,
    bundledVirtualIds: ['cyber', 'koi'],
    bundledThemeCount: 2,
    price: 1280,
    stock: 9,
    features: ['白金磨砂卡面 · 限量 200 張', '附贈 2 款主題', '全球 Phoenix 機台通用'],
  },
];

/**
 * 啟用流程步驟（4 步）。
 */
export const DART_CARD_ACTIVATION_STEPS = [
  { num: 1, title: '選擇卡型', desc: '依你常用機台選 DARTSLIVE 或 PHOENICA；限定款 / 客製款可加價' },
  { num: 2, title: '結帳寄送', desc: '一律宅配 · 滿 NT$1,000 免運 · 1–3 個工作天送達' },
  { num: 3, title: '官方註冊', desc: '收到卡片後依說明卡於 DARTSLIVE / PHOENIXdarts 官方註冊 Player ID' },
  { num: 4, title: '插卡開戰', desc: '插入機台立即記錄戰績，附贈主題會自動掛載於你的帳號' },
];
